import script from "./DeleteClaimModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteClaimModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteClaimModal.vue?vue&type=style&index=0&id=00ab04a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ab04a0"]])

export default __exports__